import React from "react";
import { IconColorE, IconSizeE } from "../../models/enums";
import Icon from "../Icon/Icon";

import styles from "./styles.module.scss";

interface LoaderI extends React.HTMLAttributes<HTMLDivElement> {}

const Loader = (props: LoaderI) => {
  return (
    <div className={`${styles.wrapper} ${props?.className || ""}`} {...props}>
      <Icon name="loading" size={IconSizeE.S} color={IconColorE.GRAY} />
    </div>
  );
};

export default Loader;
